import * as React from 'react';
import { withStyles } from "@material-ui/core";
import Icon from "storybookComponents/Icon"
import { Collapse } from "reactstrap";
import Tooltip from "storybookComponents/tooltip_new"

const styles = () => ({
  super: {
    marginBottom: "4px"
  },
  header: {
    background: "rgba(196, 196, 196, 0.2)",
    color: "black",
    padding: "4px 20px",
    fontSize: "14px",
    lineHeight: "24px",
    fontWeight: "600",
    fontFamily: "Open Sans",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  cursor: {
    cursor: "pointer",
  },
  ellipsis: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: 225
  },
  listItem: {
    height: "24px",
    margin: "4px 0px",
    fontSize: "12px",
    lineHeight: "24px",
    padding: "0px 20px",
    fontFamily: "Open Sans",
  },
  listContainer: {
    maxHeight: "250px",
    overflowY: "scroll"
  }
});



export default withStyles(styles)(({ classes, title, list, tooltip }) => {
  const [open, setOpen] = React.useState(false)

  const handleClick = () => {
    setOpen(!open)
  }

  const renderListItem = (item, index) => {
    return (
      <div className={classes.listItem} key={index}>{item}</div>
    )
  }
  if (list.length == 1) {
    const element = <div className={`${classes.header} ${classes.super}`}><div className={classes.ellipsis}>{title}</div></div>
    if (tooltip == true) {
      return <Tooltip text={list[0]} position="top">
        {element}
      </Tooltip>
    } else {
      return element
    }

  }
  return (
    <div className={classes.super}>
      <div className={`${classes.header} ${classes.cursor}`} onClick={handleClick}>{title}
        <Icon type={open ? "icon-up-arrow" : "icon-down-arrow"} size="xs" />
      </div>
      <Collapse isOpen={open}>
        <div className={classes.listContainer}>
          {list.map(renderListItem)}
        </div>
      </Collapse>
    </div>
  );
})